<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-basket</v-icon>{{ item['ref'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <OrderForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import OrderForm from '../../components/order/FormUpdate.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'Order';

export default {
  name: 'OrderUpdate',
  servicePrefix,
  mixins: [UpdateMixin,FileMixin],
  components: {
    Loading,
    Toolbar,
    OrderForm
  },
  data() {
    return {
      item: {
      }
    };
  },
  computed: {
    ...mapFields('order', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('order', ['find'])

  },

  methods: {
    ...mapActions('order', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),

  }
};
</script>